import React, { useState, useEffect } from 'react';
import Box from './Box';
import CountdownTimer from './CountdownTimer';
import PrizeBox from './PrizeBox';
import Button from './Button';
import { Modal, Carousel } from 'antd';
import ModalHeader from './ModalHeader';
import { InfoCircleFilled, PlayCircleTwoTone  } from '@ant-design/icons';
import LotteryNum from './LotteryNum';
import WinnerCustInfo from './WinnerCustInfo';
import "./custom.css";
import axios from 'axios';
import { message, Spin } from 'antd';
import { useNavigate } from "react-router-dom";

import { Collapse, theme } from 'antd';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const initialValue = {
  status: false, data: [], cnt: ""
}

const DashBoardBodySaving = ({ lottNum = 1, lottDrawDate = null, isReward = false, innRewardData = null, showprev = false, isshowlottnum = false, link = null, isComfirm = true}) => {
  const navigate = useNavigate('');
  const [isLottModalOpen, setIsLottModalOpen] = useState(false);
  const [isLottInfoModalOpen, setIsLottInfoModalOpen] = useState(false);
  const [isPrevLottInfoModalOpen, setIsPrevLottInfoModalOpen] = useState(false);
  const [winnerCustModalOpen, setWinnerCustModalOpen] = useState(false);
  const [winnerModalOpen, setWinnerModalOpen] = useState(false);
  const [showLottNum, setShowLottNum] = useState(false);
  const [showPrevResult, setShowPrevResult] = useState(false);
  const [lottNumList, setLottNumList] = useState(initialValue);
  const [prevLottNumList, setPrevLottNumList] = useState(initialValue);
  const [prevResultCust, setPrevResultCust] = useState(initialValue);
  const [checkWinnerSpin, setCheckWinnerSpin] = useState(false);

  const [rewardData, setRewardData] = useState({ status: 0, reward: ''});


  const [notWinnerModalOpen, setNotWinnerModalOpen] = useState(false);


  // let drawTime = { date: '', date2: '', time: '', time2: '' }
  let phase = 1

  const drawSchedule = [
    {
      date: new Date('2025-03-10T17:00:00'),
      drawTime: { date: '2025-03-10', date2: '2025.03.10', time: '17:00', time2: '17:00:00' },
      txt: '2025 оны 3-р сарын 10-ны өдөр эхний тохирол явагдана.',
      txt2: '2025.02.01 - 2025.02.28',
      txt3: '2025.01.01 - 2025.01.31',
      txt4: '2025.01.01 - 2025.01.31'
    },
    {
      date: new Date('2025-04-10T17:00:00'),
      drawTime: { date: '2025-04-10', date2: '2025.04.10', time: '17:00', time2: '17:00:00' },
      txt: '2025 оны 4-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.03.01 - 2025.03.31',
      txt3: '2025.02.01 - 2025.02.29',
      txt4: '2025.01.01 - 2025.02.29'
    },
    {
      date: new Date('2025-05-10T17:00:00'),
      drawTime: { date: '2025-05-10', date2: '2025.05.10', time: '17:00', time2: '17:00:00' },
      txt: '2025 оны 5-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.04.01 - 2025.04.30',
      txt3: '2025.03.01 - 2025.03.31',
      txt4: '2025.01.01 - 2025.03.31'
    },
    {
      date: new Date('2025-06-10T17:00:00'),
      drawTime: { date: '2025-06-10', date2: '2025.06.10', time: '17:00', time2: '17:00:00' },
      txt: '2025 оны 6-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.05.01 - 2025.05.31',
      txt3: '2025.04.01 - 2025.04.30',
      txt4: '2025.01.01 - 2025.04.30'
    },
    {
      date: new Date('2025-07-09T11:00:00'),
      drawTime: { date: '2025-07-09', date2: '2025.07.09', time: '11:00', time2: '11:00:00' },
      txt: '2025 оны 7-р сарын 09-ны өдөр тохирол явагдана.',
      txt2: '2025.06.01 - 2025.06.30',
      txt3: '2025.05.01 - 2025.05.31',
      txt4: '2025.01.01 - 2025.06.30'
    },
    {
      date: new Date('2025-08-10T17:00:00'),
      drawTime: { date: '2025-08-10', date2: '2025.08.10', time: '18:00', time2: '18:00:00' },
      txt: '2025 оны 08-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.07.01 - 2025.07.31',
      txt3: '2025.06.01 - 2025.06.30',
      txt4: '2025.07.01 - 2025.07.31'
    },
    {
      date: new Date('2025-09-10T18:00:00'),
      drawTime: { date: '2025-09-10', date2: '2025.09.10', time: '18:00', time2: '18:00:00' },
      txt: '2025 оны 09-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.08.01 - 2025.08.31',
      txt3: '2025.07.01 - 2025.07.31',
      txt4: '2025.07.01 - 2025.08.31'
    },
    {
      date: new Date('2025-10-10T18:00:00'),
      drawTime: { date: '2025-10-10', date2: '2025.10.10', time: '18:00', time2: '18:00:00' },
      txt: '2025 оны 10-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.09.01 - 2025.09.30',
      txt3: '2025.08.01 - 2025.08.31',
      txt4: '2025.07.01 - 2025.09.30'
    },
    {
      date: new Date('2025-11-10T18:00:00'),
      drawTime: { date: '2025-11-10', date2: '2025.11.10', time: '18:00', time2: '18:00:00' },
      txt: '2025 оны 11-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.10.01 - 2025.10.31',
      txt3: '2025.09.01 - 2025.09.30',
      txt4: '2025.07.01 - 2025.10.31'
    },
    {
      date: new Date('2025-12-10T18:00:00'),
      drawTime: { date: '2025-12-10', date2: '2025.12.10', time: '18:00', time2: '18:00:00' },
      txt: '2025 оны 12-р сарын 10-ны өдөр тохирол явагдана.',
      txt2: '2025.11.01 - 2025.11.30',
      txt3: '2025.10.01 - 2025.10.31',
      txt4: '2025.07.01 - 2025.11.30'
    },
    {
      date: new Date('2026-01-12T18:00:00'),
      drawTime: { date: '2026-01-12', date2: '2026.01.12', time: '17:00', time2: '17:00:00' },
      txt: '2026 оны 01-р сарын 12-ны өдөр тохирол явагдана.',
      txt2: '2025.12.01 - 2025.12.31',
      txt3: '2025.11.01 - 2025.11.30',
      txt4: '2025.07.01 - 2025.12.31'
    }
  ];

  const nowDate = new Date();
  const phasedate = new Date('2025-07-09T11:00:00');

// Find the current draw period 2026 оны ХМ эхэлтэл түр коммент болгов.
//   const currentDraw = drawSchedule.find(draw => nowDate < draw.date);
//   let {drawTime, txt, txt2, txt3,txt4,date} = currentDraw;

    const currentDraw = {
        date: new Date(),
        drawTime: { date: '', date2: '', time: '', time2: '' },
        txt: 'Тохирол түр хугацаагаар зогссон.',
        txt2: '',
        txt3: '',
        txt4: ''
    };
    let {drawTime, txt, txt2, txt3, txt4, date} = currentDraw;


  if (nowDate > phasedate) {
    phase = 2
  }

  useEffect(() => {
    if (isReward === 1) {
      setWinnerModalOpen(true);
      setRewardData(prevState => ({
        ...prevState, status: 1, reward: innRewardData.reward
      }));
    }

    if (isshowlottnum === 1) {
      setShowLottNum(true);
    }

    if (showprev == 1) {
      setShowPrevResult(true);
    } else {
      setShowPrevResult(false);
    }

  }, [isReward, isshowlottnum]);

  const fetchPrevLottinfo = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=prevlottinfosaving`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          if(res.data.cnt > 0){
            let data = res.data.data.map((value, index) => {

              let lnum = value.lnum.map((v, i) => {
                return (
                  <LotteryNum num={v} key={i} />
                );
              })

              let arr =  {
                key: index,
                label: <p className='text-[#0987F3] font-bold text-lg select-none'>{value.monthnum+"-р сар"}</p>,
                children: <div className='grid grid-cols-4 gap-4 text-[#0987F3] mobile:h-fit tablet:grid-cols-3 mobile:grid-cols-1'>{lnum}</div>,
                style: panelStyle
              }
              return arr
            })

            setPrevLottNumList({ status: true, data: data, cnt: res.data.cnt });
          }else{
            setPrevLottNumList({ status: true, data: [], cnt: 0 });
          }

        } else {
          message.error(res.data.msg);
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showPrevLottInfoModal = () => {
    if (showPrevResult === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (items) {
        if (prevLottNumList.status === false) {
          fetchPrevLottinfo(items);
        }
      } else {
        message.error("Session дууссан байна.");
        navigate("/login");
      }
    }
    setIsPrevLottInfoModalOpen(true);
  };

  const fetchLottInfo = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=lottinfosaving`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data
      if (res.status === true) {
        if (res.data.status == true) {
          setLottNumList({ status: true, data: res.data.data });
        } else {
          setLottNumList({ status: true, data: [] });
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  const showLotterModal = () => {
    if (showLottNum === true) {
      const items = JSON.parse(localStorage.getItem('localData'));
      if (lottNumList.status === false) {
        fetchLottInfo(items);
      }
      setIsLottInfoModalOpen(true);
    } else {
      setIsLottModalOpen(true);
    }
  };

  const lotteryhandleCancel = () => {
    setIsLottModalOpen(false);
  };

  const lotteryInfohandleCancel = () => {
    setIsLottInfoModalOpen(false);
  };

  const lotteryPrevInfohandleCancel = () => {
    setIsPrevLottInfoModalOpen(false);
  };

  const winnerCusthandleCancel = () => {
    setWinnerCustModalOpen(false);
    setPrevResultCust({ status: false, data: [] });
  };

  const winnerModalCancel = () => {
    setWinnerModalOpen(false);
  };

  const showWinnerModal = () => {
    setWinnerModalOpen(true);
  };

  const notWinnerModalCancel = () => {
    setNotWinnerModalOpen(false);
  };

  const showNotWinnerModal = () => {
    setNotWinnerModalOpen(true);
  };

  const fetchCheckWinner = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=checkiswinnersaving`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let res = response.data;
      if (res.status === true) {
        if (res.data.isreward == 1) {
          setRewardData(prevState => ({
            ...prevState, status: 1, reward: res.data.reward.RW
          }));
          showWinnerModal();
        } else if (res.data.isreward == 2) {
          setRewardData(prevState => ({
            ...prevState, status: 2, reward: "", lnum: ""
          }));
          message.info("Энэ сарын тохирол эхлээгүй байна.");
        } else {
          setRewardData(prevState => ({
            ...prevState, status: 3, reward: "", lnum: ""
          }));
          showNotWinnerModal();
        }
      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }

    setCheckWinnerSpin(false);
  }

  const checkIsWinner = () => {
    if (rewardData.status === 1) {
      showWinnerModal();
    } else if (rewardData.status === 2) {
      message.info("Энэ сарын тохирол эхлээгүй байна.");
    } else if (rewardData.status === 3) {
      showNotWinnerModal();
    } else {
      setCheckWinnerSpin(true);
      const items = JSON.parse(localStorage.getItem('localData'));
      fetchCheckWinner(items);
    }
  }

  const { token } = theme.useToken();
  const panelStyle = {
    marginBottom: 24,
    background: "#f4f4f5",
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  return (
    <div style={{ height: "calc(100% - 128px)" }} className='w-full flex'>
      <div className='w-2/3 h-full flex flex-col justify-center items-center space-y-10 laptop:space-y-2 tablet:space-y-8 tablet:w-full mobile:space-y-8 mobile:w-full laptop:h-[600px]'>
        <div className='w-full h-full flex space-x-10 laptop:space-x-2 tablet:flex-col tablet:space-x-0 tablet:space-y-8 mobile:flex-col mobile:space-x-0 mobile:space-y-8'>
          <Box style="p-8 w-1/2 h-full bg-white  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2"><CountdownTimer targetDate={drawTime.date !== '' ? (drawTime.date + " " + drawTime.time2) : ""} time={drawTime.date !== '' ? (drawTime.date2 + "-ны өдөр " + drawTime.time) : ""} size={"small"} /></Box>
          <Box style="p-8 w-1/2 h-full bg-white flex flex-col items-center justify-between  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2">
            <div className='w-full flex flex-col items-center space-y-4'>
              <div className='w-full flex justify-between'>
                <PrizeBox prize={"100,000₮"} txt={"хадгаламжийн эрх"} style="w-[200px] laptop:w-[160px] h-[50px] flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px]" type={true}/>
                <PrizeBox prize={"300,000₮"} txt={"хадгаламжийн эрх"} style="w-[200px] laptop:w-[160px] h-[50px] flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px]" type={true}/>
              </div>
              <div className='w-full flex justify-between'>
                <PrizeBox prize={"500,000₮"} txt={"хадгаламжийн эрх"} style="w-[200px] laptop:w-[160px] h-[50px] flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px]" type={true}/>
                <PrizeBox prize={"1,000,000₮"} txt={"хадгаламжийн эрх"} style="w-[200px] laptop:w-[160px] h-[50px] flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[150px]" type={true}/>
              </div >
              <PrizeBox prize={"Супер урамшуулал"} txt={"Нэг өрөө байр"} style="w-[200px] laptop:w-[160px] h-[50px] flex flex-col justify-center items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:w-[180px]" type={true}/>
            </div>
            <Button style='bg-[#0168D7] text-white text-sm font-semibold rounded-md w-full h-10 shadow-lg hover:opacity-90 duration-150' name='Өмнөх сарын эрхийн дугаар' onclick={showPrevLottInfoModal} />

            <Modal open={winnerModalOpen} onCancel={winnerModalCancel} footer={null} centered width={1000} header={null} bodyStyle={{ height: '500px', margin: -24, padding: 0 }}>
              <div className='w-full h-full relative'>
                <div className='z-50 w-full h-full my-0 absolute flex flex-col justify-center items-center  space-y-6 mobile:px-1'>
                  <img className='w-70 top-6 mobile:w-36' src="/images/hm_logo.png" />
                  <p className='text-5xl text-yellow-400 mobile:text-4xl font-semibold'>БАЯР ХҮРГЭЕ</p>
                  <p className='text-xl text-white mobile:text-base text-center'>Та Хуримтлалтай Монгол аяны хадгаламжийн эзэн болсон байна.</p>
                  {/* <div className='w-2/3 h-56 bg-white rounded-lg flex flex-col justify-between items-center relative text-[#0987F3] py-16 mobile:px-4'>

                    <p className='text-xl font-semibold mobile:text-sm mobile:text-center'>Баяр хүргэе, та урамшууллын эзэн болсон байна.</p>
                    <p className='text-5xl font-bold mobile:text-3xl'>{rewardData.reward} ₮</p>
                  </div> */}
                  <div className='w-[450px] rounded-2xl h-fit border border-blue-500 p-1 mobile:w-[300px] flex justify-center items-center'><div className='bg-white w-full rounded-xl font-semibold h-24 flex items-center justify-center text-7xl mobile:text-5xl'><p className='text-blue-800'>{rewardData.reward} ₮</p></div></div>
                  <p className='w-4/5 text-center text-blue-200 text-base font-semibold mobile:text-sm'>{txt3}-ний хооронд хугацаатай хадгаламжаа нэмэгдүүлж ХУРИМТЛАЛТАЙ МОНГОЛ аяны хадгаламжийн эзэн боллоо.</p>
                  {/* <Button style={isWinnerComfirm == 0 ? "bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[180px]  h-10 shadow-lg hover:opacity-90 duration-150" : "bg-gray-400 cursor-default text-white text-sm font-semibold rounded-md w-[180px] h-10 shadow-lg"} name={isWinnerComfirm === 0 ? 'Баталгажуулах' : 'Баталгаажсан'} onclick={winnerComfirm} /> */}
                </div>
                <img className='top-0 left-0 absolute w-full h-full object-cover z-0 rounded-lg' src="/images/back2.png" />
              </div>
            </Modal>

            <Modal open={notWinnerModalOpen} onCancel={notWinnerModalCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"Тохирол шалгах"} />
              <div className='w-full h-[430px] flex flex-col items-center justify-center text-center text-xl font-semibold text-[#0987F3] mobile:text-lg'>
                <p>Та хараахан урамшууллын эзэн болоогүй байна.<br/>Хугацаатай хадгаламждаа орлого нэмэн дараа сарын тохиролдоо оролцоорой.</p>
              </div>
            </Modal>

            {/* aztan bolson hariltsagchiin medeelel */}
            <Modal open={winnerCustModalOpen} onCancel={winnerCusthandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"өмнөх тохирлын азтан"} />
              <div className='w-full h-[465px] flex flex-col items-center justify-start space-y-4 py-4 overflow-y-auto text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>
                {prevResultCust.status === true ? (<>
                  {prevResultCust.data.map((e, index) => {
                    return (
                      <WinnerCustInfo name={e.name} regno={e.reg} key={index} />
                    );
                  })}
                </>) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
              </div>
            </Modal>
            {/* aztan bolson hariltsagchiin medeelel */}

            {/* omnoh sariin sugalaanii dugaar */}
            <Modal zIndex={1} open={isPrevLottInfoModalOpen} onCancel={lotteryPrevInfohandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[475px] flex flex-col items-center justify-between text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>

                {prevLottNumList.status === true ? (prevLottNumList.data.length > 0 ? (<div className='w-full max-h-[360px] mobile:max-h-[330px] overflow-auto pr-1 my-custom-scrollbar my-6 mobile:h-fit tablet:grid-cols-3 mobile:grid-cols-1'>

                  <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => <div className='text-[#0987F3] text-2xl'><PlayCircleTwoTone style={{ fontSize: '20px'}} rotate={isActive ? 90 : 0} /></div>}
                    style={{
                      background: token.colorBgContainer,
                    }}
                    items={prevLottNumList.data}
                  />
                </div>) : (<div className='w-full h-full flex justify-center items-center text-xl font-semibold'><p>Танд сугалаа байхгүй байна.</p></div>)) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
                <div className='w-full h-[115px] flex flex-col justify-end items-center space-y-3 mobile:space-y-3 mobile:h-[145px]'>
                  <div className='w-full h-fit flex justify-between items-end mobile:flex-col mobile:h-fit mobile:space-y-3'>
                    <div className='flex flex-col text-start mobile:text-base mobile:text-center mobile:w-full'>
                      <p>Хамрах хугацаа:</p>
                      <p>{txt4}</p>
                    </div>
                    <div className='flex flex-col text-end mobile:text-base mobile:text-center mobile:w-full'>
                      <p>Супер тохиролд оролцох эрх:</p>
                      <p>{prevLottNumList.cnt} ширхэг</p>
                    </div>
                  </div>
                  {checkWinnerSpin ? (<div className='w-full h-10 flex items-center justify-center'><Spin /></div>) : (<div className='w-full h-10 flex items-center justify-center'><Button style="bg-[#0168D7] text-white text-center text-sm font-semibold rounded-md w-fit px-8 h-10 shadow-lg hover:opacity-90 duration-150" name='Тохирол шалгах' onclick={checkIsWinner} /></div>)}
                </div>
              </div>

            </Modal>
            {/* omnoh sariin sugalaanii dugaar */}
          </Box>
        </div>
        <div className='w-full h-full flex space-x-10 laptop:space-x-2  tablet:flex-col tablet:space-x-0 tablet:space-y-8 mobile:flex-col mobile:space-x-0 mobile:space-y-8'>
          <Box style="p-10 w-1/2 h-full bg-white flex flex-col justify-between items-center  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] mobile:w-full mobile:h-[330px] mobile:px-2">
            <p className='uppercase text-[#0987F3] font-semibold text-xl'>миний урамшууллын эрх</p>
            <div className='flex flex-col justify-center items-center text-[#0987F3]'><p className='font-bold text-7xl'>{lottNum}</p><p className='text-xl'>ширхэг</p></div>
            <Button style="bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[200px] h-10 shadow-lg hover:opacity-90 duration-150" name='Эрхийн дугаар харах' onclick={showLotterModal} />
            <Modal open={isLottModalOpen} onCancel={lotteryhandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[430px] flex flex-col items-center justify-center text-center text-xl font-semibold text-[#0987F3] space-y-5'>
                <div className='flex items-start space-x-3 mobile:text-lg'>
                  <p className='mobile:flex mobile:flex-col mobile:justify-center items-center'><InfoCircleFilled className='mt-1 mr-2' /> <span>Таны нууцыг хамгаалахын тулд тохирол болохоос 2 хоногийн өмнө <br /> урамшууллын эрхийн дугаар байршуулна.</span></p>
                </div>
                <p>{txt}</p>
              </div>
            </Modal>

            <Modal open={isLottInfoModalOpen} onCancel={lotteryInfohandleCancel} footer={null} centered width={1000} bodyStyle={{ height: '500px', margin: 0, padding: 0 }}>
              <ModalHeader text={"миний урамшууллын эрхийн дугаар"} />
              <div className='w-full h-[465px] flex flex-col items-center justify-between text-center text-xl font-semibold text-[#0987F3] px-16 mobile:px-2 mobile:h-[470px]'>

                {lottNumList.status === true ? (lottNumList.data.length > 0 ? (<div className='w-full grid grid-cols-4 gap-4 overflow-auto pr-1 my-custom-scrollbar my-6 mobile:h-fit tablet:grid-cols-3 mobile:grid-cols-1'>
                  {lottNumList.data.map((lnum, index) => {
                    return (
                      <LotteryNum num={lnum} key={index} />
                    );
                  })}
                </div>) : (<div className='w-full h-full flex justify-center items-center text-xl font-semibold'><p>Танд сугалаа байхгүй байна.</p></div>)) : (<div className='h-full w-full flex justify-center items-center'><Spin /></div>)}
                <div className='w-full h-1/6 flex justify-between items-end mobile:flex-col mobile:h-fit mobile:space-y-3'>
                  <div className='flex flex-col text-start mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Хамрах хугацаа:</p>
                    <p>{txt2}</p>
                  </div>
                  <div className='flex flex-col text-end mobile:text-base mobile:text-center mobile:w-full'>
                    <p>Таны нийт урамшууллын дугаар:</p>
                    <p>{lottNum} ширхэг</p>
                  </div>
                </div>
              </div>
            </Modal>
          </Box>
          <Box style="p-10 w-1/2 h-full bg-white laptop:p-2 laptop:py-6 tablet:w-full tablet:h-[330px] tablet:px-24 mobile:w-full mobile:h-[330px] mobile:px-2">
            <p className='uppercase text-[#0987F3] font-semibold text-xl'>шууд тохирлын видео</p>
            {link !== '' ? (<iframe className='w-full h-full' src={"https://www.facebook.com/plugins/video.php?href=" + link} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>) : ''}
          </Box>
        </div>
      </div>

      <div className='w-1/3 pl-10 laptop:pl-2 tablet:hidden mobile:hidden laptop:h-[600px]'>
        <Box style="w-full h-full bg-white">
          <Carousel speed={700} autoplaySpeed={4000} autoplay>
            <img className='object-cover w-full h-[calc(100vh_-_288px)] rounded-lg' src={phase == 1 ? "/images/hm_mobile_20250721.jpg" : "/images/HM-2026-1-Mobile.png"} />
            <img className='object-cover w-full h-[calc(100vh_-_288px)] rounded-lg' src={phase == 1 ? "/images/hm_mobile_20250721.jpg" : "/images/HM-2026-1-Mobile.png"} />
          </Carousel>
        </Box>
      </div>
    </div>
  );
}

export default DashBoardBodySaving;